import { createAsyncThunk } from "@reduxjs/toolkit";
import { bffApi, type MarketDialogueDto } from "../../autogen/bff-api";
import { untilSettled } from "../../common/redux/untilSettled";

export const fetchSettledMarketDialogue = createAsyncThunk<MarketDialogueDto, { marketDialogueId: string }>(
  "marketDialogue/fetchSettled",
  async ({ marketDialogueId }, { dispatch, getState, rejectWithValue }) => {
    const select = bffApi.endpoints.getMarketDialogue.select({ marketDialogueId });
    const request = dispatch(bffApi.endpoints.getMarketDialogue.initiate({ marketDialogueId }, { forceRefetch: true }));
    try {
      return await untilSettled(await request, () => select(getState() as Parameters<typeof select>[0]));
    } catch (e) {
      return rejectWithValue(e);
    } finally {
      request.unsubscribe();
    }
  },
);
